import HttpService from '../HttpService'

export async function getUnitInfo (url, ctx) {
  try {
    const locale = $nuxt.$store.$i18n.locale;
    const { data } = await HttpService.query().setPath('/view/convert/' + url + '?lang=' + locale).get()
    ctx.$store.commit('updateInfo', data)
    return data
  } catch (e) {
    return null
  }
}
